module.exports = __webpack_public_path__ + "media/images/knockout__pickarrow--inactive@3x-330af7fed5fea3b84dd5bfb019b14d27.png";